import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { EntityHistory_entity$key } from '__generated__/EntityHistory_entity.graphql';
import EntityHistoryEntry from 'components/EntityHistoryEntry';

type Props = {
  entity: EntityHistory_entity$key;
};

const EntityHistory: FC<Props> = ({ entity }) => {
  const { logs } = useFragment(
    graphql`
      fragment EntityHistory_entity on Logable {
        logs {
          id
          ...EntityHistoryEntry_entry
        }
      }
    `,
    entity
  );

  return (
    <div>
      {logs.map(logEntry => (
        <EntityHistoryEntry key={logEntry.id} entry={logEntry} />
      ))}
    </div>
  );
};

export default EntityHistory;
